import { useState } from "react";
import { ImapTable } from "../../features/imap/imap-table";
import { useGetEmailsFromMailingIntegrationQuery } from "../../features/integrations/integrationsApiSlice";

export const IMAP = () => {
	const [pagination, setPagination] = useState({
		pageIndex: 0,
		pageSize: 20, // Number of rows per page
	});

	const {
		data: mails,
		error: mailsError,
		isLoading: isLoadingMails,
		isFetching: isFetchingMails,
	} = useGetEmailsFromMailingIntegrationQuery({
		page: pagination.pageIndex,
		perPage: pagination.pageSize,
	});

	// todo: redirect to main page?

	if (isLoadingMails || isFetchingMails) {
		return <h1>Loading...</h1>;
	}

	return (
		<div>
			<ImapTable
				data={mails?.INBOX.messages || []}
				paginationState={{
					pagination: pagination,
					setPagination: setPagination,
					total: mails.INBOX.total,
				}}
			/>
		</div>
	);
};
